import { createAction, createReducer, createSlice } from "@reduxjs/toolkit";

export const generateUpdateStepperStateAction = createAction("controlsState/updateStepperState")

const initState = {
  activeStep: 0
  ,
  showReturnDialog: false,
  animationClass: "animate__fadeInRight",
  annonymously: false,
};
export const stateSlice = createSlice({
  name: "controlsState",
  initialState: initState,
  reducers: {
    updateStepperState: (state, action) => {
      state.activeStep = action.payload.activeStep;
    },
    showReturnDialog: (state, action) => {
      state.showReturnDialog = action.payload;
    },
    setAnimationClass: (state, action) => {
      state.animationClass = action.payload
    },
    setAnnonymously: (state) => {
      state.annonymously = true;
    }
  },
});

export const { updateStepperState, showReturnDialog, setAnimationClass, setAnnonymously } = stateSlice.actions;
